const rootSelector = '[data-home-diana-read-more]';
const contentSelector = '[data-home-diana-read-more-content]';
const toggleSelector = '[data-home-diana-read-more-toggle]';
const initializedRoots = new WeakSet();
const roots = new Set();

const getCollapsedHeight = (root) => {
  const height = Number.parseFloat(
    window.getComputedStyle(root).getPropertyValue('--home-diana-read-more-height'),
  );

  return Number.isFinite(height) ? height : 0;
};

const updateReadMore = (root) => {
  const content = root.querySelector(contentSelector);
  const toggle = root.querySelector(toggleSelector);
  const collapsedHeight = getCollapsedHeight(root);

  if (!content || !toggle || root.classList.contains('is-expanded')) {
    return;
  }

  content.classList.remove('is-collapsed');
  root.classList.remove('is-ready');

  if (collapsedHeight === 0 || content.scrollHeight <= collapsedHeight + 1) {
    toggle.hidden = true;
    return;
  }

  content.classList.add('is-collapsed');
  toggle.hidden = false;
  root.classList.add('is-ready');
};

const updateAllReadMore = () => {
  roots.forEach((root) => updateReadMore(root));
};

let resizeFrame;
window.addEventListener('resize', () => {
  window.cancelAnimationFrame(resizeFrame);
  resizeFrame = window.requestAnimationFrame(updateAllReadMore);
}, { passive: true });
window.addEventListener('load', updateAllReadMore, { once: true });

const initHomeDianaReadMore = (scope = document) => {
  scope.querySelectorAll(rootSelector).forEach((root) => {
    if (initializedRoots.has(root)) {
      return;
    }

    const content = root.querySelector(contentSelector);
    const toggle = root.querySelector(toggleSelector);
    const section = root.closest('.home-diana-sec');

    if (!content || !toggle || content.id === '') {
      return;
    }

    initializedRoots.add(root);
    roots.add(root);

    toggle.setAttribute('aria-controls', content.id);
    toggle.setAttribute('aria-expanded', 'false');
    toggle.addEventListener('click', () => {
      root.classList.add('is-expanded');
      section?.classList.add('is-expanded');
      content.classList.remove('is-collapsed');
      toggle.hidden = true;
      toggle.setAttribute('aria-expanded', 'true');
    });

    updateReadMore(root);
  });
};

initHomeDianaReadMore();
